import { styled } from '@mui/material/styles';
import { Box, Collapse } from '@mui/material';
import PromptInputModal from './PromptInputModal';
import useBuildWiseGPT from './hooks/useBuildWiseGPT';
import PromptInput from './PromptInput';
import PromptHistory from './PromptHistory';
import RenderChatDate from './RenderChatDate';
import { useLocation } from 'react-router-dom';

function BuildWiseGPT() {
  const { pathname } = useLocation();
  const type = pathname.includes('/buildwise-gpt/chat')
    ? 'chat'
    : pathname.includes('/buildwise-gpt/text')
      ? 'text'
      : '';
  const {
    attachments,
    collpasedDates,
    containerRef,
    history,
    historyData,
    inputRef,
    loading,
    openFullViewModal,
    value,
    bookmarkPrompt,
    handleFileUploads,
    handleKeyDown,
    handleRemoveAttachment,
    onClose,
    onFullModalMinimized,
    onNewSession,
    onSend,
    regeneratePrompt,
    setAttachments,
    setCollapsedDates,
    setFullViewModal,
    setValue,
  } = useBuildWiseGPT({ type });

  return (
    <Container>
      <ChatHistoryContainer>
        {historyData.map((item) => {
          return (
            <Box
              sx={(theme) => ({ borderTop: `1px solid ${theme.palette.custom.divider}`, mt: 4 })}
              key={item.date}
            >
              <RenderChatDate
                date={item.date}
                collapsedDates={collpasedDates}
                setCollapsedDates={setCollapsedDates}
              />
              <Collapse in={!collpasedDates.includes(item.date)}>
                {item.data.map((chat) => (
                  <PromptHistory
                    key={chat._id}
                    item={chat}
                    loading={loading}
                    formattedResponse={chat.genAIResponse}
                    bookmarkPrompt={bookmarkPrompt}
                    regeneratePrompt={regeneratePrompt}
                  />
                ))}
              </Collapse>
            </Box>
          );
        })}
        <Box ref={containerRef} />
      </ChatHistoryContainer>
      <PromptInput
        ref={inputRef}
        value={value}
        handleKeyDown={handleKeyDown}
        onSend={onSend}
        setFullViewModal={setFullViewModal}
        setValue={setValue}
        regeneratePrompt={regeneratePrompt}
        hideRegenerate={!history.length}
        attachments={attachments}
        handleFileUploads={handleFileUploads}
        handleRemoveAttachment={handleRemoveAttachment}
        {...(type === 'text' && { allowAttachments: true })}
        {...(type === 'chat' && { onNewSession })}
      />

      {openFullViewModal && (
        <PromptInputModal
          attachments={attachments}
          open={openFullViewModal}
          enteredValue={value}
          setOpen={setFullViewModal}
          onFullModalMinimized={onFullModalMinimized}
          onSend={onSend}
          onClose={onClose}
          handleFileUploads={handleFileUploads}
          handleRemoveAttachment={handleRemoveAttachment}
          {...(type === 'text' && { allowAttachments: true })}
        />
      )}
    </Container>
  );
}

const Container = styled(Box, { label: 'Container' })({
  minHeight: '100vh',
});

const ChatHistoryContainer = styled(Box, { label: 'ChatHistoryContainer' })({
  minHeight: '100vh',
  maxWidth: '80%',
  margin: '0 auto 48px',
});

export default BuildWiseGPT;
